module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/cm-gallery/cm-gallery-05-38abf2336b707efe674a7e7869a3924f.jpg";